<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div>

            <div class="flex sm:flex-row gap-2">
                <div>
                    <div>
                        <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
                            [owlDateTimeTrigger]="date" [selectMode]="'range'" [readOnly]="true" />
                        <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange($event)"
                            #date></owl-date-time>
                    </div>
                </div>
                <div *ngIf="setTab ==='company'">
                    <ng-select class="w-full sm:w-44" [(ngModel)]="selectedCompany" (change)="filterBySelection()" [clearable]="false">
                        <ng-option value="">Select Company</ng-option>
                        <ng-option *ngFor="let company of allCompanies" [value]="company">{{ company.name | titlecase }}
                        </ng-option>
                    </ng-select>
                </div>
                <div *ngIf="setTab ==='fundingsource'">
                    <ng-select class="w-full sm:w-44" [(ngModel)]="selectedFundingsource" (change)="filterBySelection()" [clearable]="false"
                        [searchable]="true">
                        <ng-option value="">Select FS</ng-option>
                        <ng-option *ngFor="let fundingsource of fundingSourceList" [value]="fundingsource">{{
                            fundingsource.title
                            | titlecase }}</ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
        <div class="flex flex-col sm:flex-row gap-2">
            <div
                class="inline-flex flex-wrap p-1 rounded-lg gap-0.5 bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none">

                <div [ngClass]="setTab === 'company' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeState('company')" class="cursor-pointer">
                    Company Wise
                </div>
                <div [ngClass]="setTab === 'fundingsource' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeState('fundingsource')" class="cursor-pointer">
                    Funding Source Wise
                </div>
            </div>
              <div
                class="inline-flex flex-wrap p-1 rounded-lg gap-0.5 bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none">

                <div [ngClass]="source === 'original' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeSource('original')" class="cursor-pointer">
                    Original
                </div>
                <div [ngClass]="source === 'billing' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeSource('billing')" class="cursor-pointer">
                    Company Adjusted
                </div>
                <div [ngClass]="source === 'fundingsource' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeSource('fundingsource')" class="cursor-pointer">
                    Funding Source Adjusted
                </div>
            </div>
            <select *ngIf="source !== 'original'" class="w-full sm:w-36" [(ngModel)]="paymentStatus"
                (change)="onPaymentFilterChange()">
                <option value="">All Payments</option>
                <option value="paid">Paid</option>
                <option value="unpaid">Unpaid</option>
            </select>
            <button class="btn btn-secondary" (click)="generateKpiData()">
                Download
            </button>

        </div>
    </div>
    
    <div class="overflow-x-hidden">
    <h2 *ngIf="source !== 'original'" class="mt-4"><label class="font-bold" for="">Finance</label></h2>
    <div *ngIf="source !== 'original'" class="grid grid-col-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">

        <!-- Paid Amount -->
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Paid Amount </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.paidAmount?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>

        <!-- Unpaid Amount -->
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Unpaid Amount </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.unpaidAmount?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>

        <!-- Total Amount -->
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total Amount </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.totalAmount?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>
    </div>

        <h2><label class="font-bold" for="">Actual Amount</label></h2>
    <div class="grid grid-col-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">

        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total FS </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.actualFSTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>

        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total Company </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate" >
                        {{kpiData?.actualCompanyTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>

        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total Commission </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.actualCommissionTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total Pre Special </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.preSpecialTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>
        <!-- total special fare -->
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total Special </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.specialTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>
    </div>

    <h2><label class="font-bold" for="">Flat Amount</label></h2>
    <div class="grid grid-col-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">

        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total FS </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.flatFSTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>

        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total Company </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.flatCompanyTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>

        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total Commission </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.flatCommissionTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Pre Special Rate </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.preSpecialTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>
        <!-- total special fare -->
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Special Rate </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.specialTotal?.toFixed(2) || '0' }}
                    </div>
                </dd>
            </dl>
        </div>
    </div>

    <h2><label class="font-bold" for="">Trips</label></h2>
    <div class="grid grid-col-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Total Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate"> {{kpiData?.total || '0' }}
                    </div>
                </dd>
            </dl>
        </div>
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Cancelled Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.totalCancelled || '0'}} </div>
                </dd>
            </dl>
        </div>
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Arrived Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.totalArrived || '0'}} </div>
                </dd>
            </dl>
        </div>
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> In Progress Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.totalInprogress || '0'}} </div>
                </dd>
            </dl>
        </div>
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Offered Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.totalOffered || '0'}} </div>
                </dd>
            </dl>
        </div>
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Onway Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.totalOnway || '0'}} </div>
                </dd>
            </dl>
        </div>
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Reroute Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate">
                        {{kpiData?.totalReroute || '0'}} </div>
                </dd>
            </dl>
        </div>
        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Scheduled Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate"> {{kpiData?.totalScheduled || '0'}}
                    </div>
                </dd>
            </dl>
        </div>

        <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Completed Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate"> {{kpiData?.totalCompleted || '0'}}
                    </div>
                </dd>
            </dl>
        </div>

        <div *ngIf="source !== 'original'" class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Paid Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate"> {{kpiData?.totalPaid || '0'}}
                    </div>
                </dd>
            </dl>
        </div>

        <div *ngIf="source !== 'original'" class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
            <dl class="flex items-center">
                <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
                    <svg class="h-8 w-8 text-base-dark" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
                    </svg>
                </dt>
                <dd class="w-full ml-4 truncate text-right">
                    <div class="text-xs-light flex-1 truncate"> Unpaid Trips </div>
                    <div class="text-xl font-bold text-base-dark flex-1 truncate"> {{kpiData?.totalUnpaid || '0'}}
                    </div>
                </dd>
            </dl>
        </div>
    </div>

    <div
        class="h-full overflow-hidden p-2 mt-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{setTab === 'company' ? 'Company' : 'Fundingsource'}}
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Scheduled
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        In Progress
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Cancelled
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Onway
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Reroute
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Offered
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Arrived
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Completed
                                    </th>
                                    <th *ngIf="source !== 'original'"
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Paid
                                    </th>
                                    <th *ngIf="source !== 'original'"
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Unpaid
                                    </th>

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Total Trips
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Pre Special Rate
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Special Rate
                                    </th>

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Flat FS
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Flat Company
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Actual FS
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Actual Company
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Flat Commission
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Actual Commission
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                                    *ngFor="let item of entities; let i=index">
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{i+1}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span *ngIf="item.type === 'company'">{{ ((item.company?.name)| titlecase) ||
                                            'N/A' }}</span>
                                        <span *ngIf="item.type === 'fundingsource'">{{ ((item.fundingsource?.title) |
                                            titlecase) || 'N/A' }}</span>
                                        <span *ngIf="item.type === 'unassigned'">{{ (item.type | titlecase) || 'N/A'
                                            }}</span>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalScheduled}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalInprogress}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalCancelled}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalOnway}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalReroute}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalOffered}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalArrived}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalCompleted}}
                                    </td>
                                    <td *ngIf="source !== 'original'"
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalPaid || 0}}
                                    </td>
                                    <td *ngIf="source !== 'original'"
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.totalUnpaid || 0}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.total}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        ${{item?.preSpecialTotal?.toFixed(2)}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        ${{item.specialTotal.toFixed(2)}}
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        ${{item?.flatFSTotal?.toFixed(2)}}
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        ${{item.flatCompanyTotal.toFixed(2)}}
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap font-bold bg-zinc-50 dark:bg-zinc-950">
                                        ${{item.actualFSTotal.toFixed(2)}}
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap font-bold bg-zinc-50 dark:bg-zinc-950">
                                        ${{item.actualCompanyTotal.toFixed(2)}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        ${{item.flatCommissionTotal.toFixed(2)}}
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap font-bold bg-zinc-50 dark:bg-zinc-950">
                                        ${{item.actualCommissionTotal.toFixed(2)}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</section>